<template>
  <section v-bind:id="id" class="section">
    <h2>
      <i class="material-icons left">{{ iconName }}</i>
      {{ title }}
    </h2>

    <p v-if="!hasDadosFuncionais" class="flow-text center">
      Nenhum vínculo foi encontrado.
    </p>
    <div v-else>
      <BaseAlert v-if="hasVinculoNaoImplantado" severity="warning"
        >Você possui pelo menos um vínculo na fila de implantação</BaseAlert
      >
      <BaseProgressBar v-if="loading" v-bind="progressBar">
        Carregando dados auxiliares...
      </BaseProgressBar>
      <BaseCollection v-else-if="hasVinculoImplantado">
        <template v-slot:items>
          <li
            v-for="(item, index) in dadoFuncionalCollection.items"
            v-bind:key="index"
            class="collection-item"
          >
            <BaseDadoFuncional v-bind="item" />
          </li>
        </template>
      </BaseCollection>
    </div>
  </section>
</template>

<script>
import { API_URL } from "../../constants";
import BaseDadoFuncional from "./BaseDadoFuncional.vue";

export default {
  name: "DadosFuncionais",
  components: {
    BaseDadoFuncional
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true
    },

    title: String,
    iconName: String,

    dadosFuncionais: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loadingTiposDiplomaLegal: false,
      loadingRegimesJuridicos: false,
      progressBar: {
        useContainer: false
      },
      tiposDiplomaLegal: [],
      regimesJuridicos: [],
      dadoFuncionalCollection: {
        items: this.dadosFuncionais
          .filter(item => item.implantado)
          .map(item => {
            return {
              value: { ...item }
            };
          })
      }
    };
  },
  computed: {
    hasDadosFuncionais() {
      return !this.$utils.Lang.isEmpty(this.dadosFuncionais);
    },
    hasVinculoImplantado() {
      return (this.dadoFuncionalCollection.items || []).length;
    },
    hasVinculoNaoImplantado() {
      return (
        (this.dadosFuncionais || []).findIndex(item => !item.implantado) >= 0
      );
    },
    loading() {
      return this.loadingTiposDiplomaLegal || this.loadingRegimesJuridicos;
    }
  },
  created() {
    this.getTiposDiplomaLegal();
    this.getRegimesJuridicos();
  },
  mounted() {
    if (this.hasVinculoNaoImplantado) {
      this.$notification.pushWarning(
        "Você possui pelo menos um vínculo na fila de implantação"
      );
    }
  },
  methods: {
    getTiposDiplomaLegal() {
      this.tiposDiplomaLegal = [];

      this.loadingTiposDiplomaLegal = true;

      this.$http
        .get(`${API_URL}/core/tipoDiplomaLegal`)
        .then(response => {
          this.tiposDiplomaLegal = response.data;

          this.dadoFuncionalCollection.items.forEach(item => {
            item.tiposDiplomaLegal = this.tiposDiplomaLegal;
          });
        })
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao obter a lista de tipos de diploma legal: ${error.message}`
          )
        )
        .finally(() => (this.loadingTiposDiplomaLegal = false));
    },
    getRegimesJuridicos() {
      this.regimesJuridicos = [];

      this.loadingRegimesJuridicos = true;

      this.$http
        .get(`${API_URL}/core/regimeJuridico`)
        .then(response => {
          this.regimesJuridicos = response.data;

          this.dadoFuncionalCollection.items.forEach(item => {
            item.regimesJuridicos = this.regimesJuridicos;
          });
        })
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao obter a lista de regimes jurídicos: ${error.message}`
          )
        )
        .finally(() => (this.loadingRegimesJuridicos = false));
    }
  }
};
</script>
